module.exports = __webpack_public_path__ + "img/17871_S.b7e9847f.png";